export default __webpack_public_path__ + "static/media/whats_pc.ec799f9a.jpg";